export const esFechaValida = (dia, mes, ano) => {
  if (!dia || !mes || !ano) return false;
  if (ano.length <= 3) return false;
  const fecha = new Date(
    `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`,
  );
  return !isNaN(fecha.getTime());
};
